import { type LucideIcon } from "lucide-react";

// Single source of truth for the "coming soon" integration tiles in
// /settings/connections. Active integrations (Strava, Google Calendar)
// stay as hardcoded <ConnectionCard> JSX in the page because each carries
// its own state wiring + handlers — a config-driven render would force a
// discriminated registry that's overkill for two cards.
//
// The page reads INTEGRATIONS and renders one section per
// IntegrationCategory, with section headers driven by i18n.

export type IntegrationCategory = "active" | "calendar_productivity" | "wearables_health";
export type IntegrationStatus = "active" | "coming_soon";

export interface IntegrationConfig {
  id: string;
  nameKey: string;
  descriptionKey: string;
  icon: LucideIcon;
  color: string;
  category: IntegrationCategory;
  status: IntegrationStatus;
}

// VAZIA — e isso é o ponto da entrega de 29/07, não um esquecimento.
//
// Esta lista existia para as integrações que a gente PROMETIA. As três últimas
// saíram daqui porque viraram integrações que FUNCIONAM, com card ao vivo em
// SettingsConnections:
//
//   notion    → notion-oauth-init/callback + notion-pull (páginas → notes)
//   spotify   → spotify-oauth-init/callback + spotify-pull (escuta → health_metrics)
//   health_native → @capgo/capacitor-health, Apple Saúde (iOS) / Health Connect
//                   (Android), lendo sono, FC, HRV, passos e treinos.
//
// A nota que estava no tile de saúde dizia que o plugin só poderia voltar
// junto das telas que MOSTRAM o dado, senão é reprovação G2.5.1 na Apple
// (foi o que derrubou o build 26; commit 5466a4f arrancou tudo). Voltou junto:
// /health/metrics tem os valores, o histórico, editar e apagar.
//
// Antes daqui também saíram: ifttt (cortado da estratégia), whoop + garmin
// (consolidação de wearables), oura + fitbit (nunca operacionalizados — as
// seis edge functions órfãs foram REMOVIDAS em 29/07). WHOOP, Garmin, Oura e
// Fitbit não voltam como integração direta: o hub do SO já lê os quatro.
// Strava fica de fora por ser atividade, não saúde. Google Fit foi
// descontinuado pelo Google em 31/08/2024.
//
// Mantida (em vez de deletada) porque é o lugar certo para o próximo "em
// breve" — e as duas seções que a consomem em SettingsConnections já se
// escondem sozinhas quando a lista está vazia.
export const INTEGRATIONS: IntegrationConfig[] = [];

export function integrationsByCategory(category: IntegrationCategory): IntegrationConfig[] {
  return INTEGRATIONS.filter((i) => i.category === category);
}
